import { Outlet } from 'react-router-dom';

import { AppShell } from '@/app/shell/AppShell';

export function RootLayout(): React.JSX.Element {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
